export default "__VITE_PUBLIC_ASSET__01a9be47__"